var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_page_members_owner_MVP-2_desktop",
    transform: "translate(-1337.000000, -168.000000)",
    fill: "#A5BFCE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section-1",
    transform: "translate(361.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-String-Desktop",
    transform: "translate(1.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-string-desktop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M992.341122,13.2279152 C993.219683,14.1064761 993.219683,15.5309874 992.340779,16.4098916 L988.500654,20.2500161 L979.949295,28.8014102 L975.936548,29.2447075 C975.904928,29.2482437 975.873274,29.2499946 975.841997,29.2499946 C975.347339,29.2499946 974.949017,28.8182673 975.005287,28.3127258 L975.451743,24.2971981 L983.999979,15.7493402 L987.840446,11.9088723 C988.279555,11.4697636 988.855409,11.2500376 989.431263,11.2500376 C990.007117,11.2500376 990.582971,11.4697636 991.022423,11.9092157 L992.341122,13.2279152 Z M979.174795,27.1894794 L988.398001,17.9662729 L986.283722,15.8519934 L977.063674,25.0720413 L976.798938,27.451743 L979.174795,27.1894794 Z M991.147564,15.2163672 C991.366946,14.9973278 991.366946,14.6405133 991.147564,14.4207873 L989.828864,13.1020534 C989.685802,12.9586135 989.518089,12.9371902 989.431263,12.9371902 C989.344402,12.9371902 989.177067,12.9586135 989.033627,13.1020534 L987.476937,14.6587781 L989.590873,16.7730575 L991.147564,15.2163672 Z",
    id: "edit-icon"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.39f6c014.svg";
export { ForwardRef as ReactComponent };